import postApi from '@/common/requset/postApi.js';

// 获取云商户信息
const fClouldUserManger = async (phoneNo) => {
	let postJson = {};
	postJson['METHOD_NAME'] = 'CLOULD_USER_MANGER';
	postJson['PHONE_NO'] = '18957102098';
	postJson['USER_PHONE'] = phoneNo;
	postJson['OPER'] = 'GET_USER_INFO';
	let result = await postApi.fPostToZmCloudApi(postJson).then(res => {
			return res;
		})
		.catch(err => {
			return err;
		});
	
	return result;
}

//获取七牛token
//华东 http(s)://up.qiniup.com
//华北 http(s)://up-z1.qiniup.com
//华南 http(s)://up-z2.qiniup.com
let fGetQiNiuToken = async (userPhone, scope) => {
	let postJson = {};
	postJson['METHOD_NAME'] = 'GET_QINIU_TOKEN';
	postJson['PHONE_NO'] = '18957102098';
	postJson['USER_PHONE'] = userPhone;
	postJson['SCOPE'] = scope;
	let result = await postApi.fPostToZmCloudApi(postJson).then(res => {
			return res;
		})
		.catch(err => {
			return err;
		});

	return result;
};

//获取云图片库信息
let fCloudImgManger = async (searchStr, pageNo, pageSize) => {
	let postJson = {};
	postJson['METHOD_NAME'] = 'CLOUD_IMG_MANGER';
	postJson['PHONE_NO'] = '18957102098';
	postJson['OPER'] = 'GET';
	postJson['IMG_TYPE'] = 'PRO_MAIN';
	postJson['SEARCH_STR'] = searchStr;
	postJson['PAGE_NO'] = pageNo;
	postJson['PAGE_SIZE'] = pageSize;
	let result = await postApi.fPostToZmCloudApi(postJson).then(res => {
			return res;
		})
		.catch(err => {
			return err;
		});

	return result;
};




export default {
	fClouldUserManger,//获取云商户信息
	fGetQiNiuToken, //获取七牛token
	fCloudImgManger, //获取云图片库信息
}



// WEBPACK FOOTER //
// ./src/common/requset/zmCloudApi.js